import SvgGpsFixed from "../../assets/components/GpsFixed.js";
import SvgGpsOff from "../../assets/components/GpsOff.js";
import SvgHourglassEmpty from "../../assets/components/HourglassEmpty.js";
import SvgHourglassFull from "../../assets/components/HourglassFull.js";
import SvgIosSpeedometer from "../../assets/components/IosSpeedometer.js";
import SvgLocalParking from "../../assets/components/LocalParking.js";
import SvgSignalCellular4Bar from "../../assets/components/SignalCellular4Bar.js";
import SvgSignalCellularOff from "../../assets/components/SignalCellularOff.js";
import Info from "../../assets/components/Info.js";

import SVG_ALL from '../../assets/svg/icon_all.svg' ;
import SVG_MOVING from '../../assets/svg/iconmonstr-navigation-1.svg' ;
import SVG_IDLING from '../../assets/svg/iconmonstr-media-control-49.svg' ;
import SVG_PARKING from '../../assets/svg/icon_parking.svg' ;
import SVG_DISCONNECT from '../../assets/svg/icon_ligthing.svg' ;

import SVG_INFO from '../../assets/svg/icon-info.svg'
import SVG_WARNING from '../../assets/svg/icon-warning.svg'
import SVG_CRITICAL from '../../assets/svg/icon-critical.svg'
import SVG_CONTROL from '../../assets/svg/icon-control-24px.svg'

import SVG_TRIP_EVENT_INFO from '../../assets/svg/trip_record_info.svg'
import SVG_TRIP_EVENT_WARNING from '../../assets/svg/trip_record_warning.svg'
import SVG_TRIP_EVENT_CRITICAL from '../../assets/svg/trip_record_critical.svg'

const EVENT_SVG = {
    gpsFull: SvgGpsFixed,
    gpsNo: SvgGpsOff,
    idleOver: SvgHourglassFull,
    idleNormal: SvgHourglassEmpty,
    parking: SvgLocalParking,
    cellFull: SvgSignalCellular4Bar,
    cellNo: SvgSignalCellularOff,
    speed: SvgIosSpeedometer,
    info: Info
}

const VEHICLE_TRANSIT_STATUS_OBJECT = {
    ALL: 'ALL',
    MOVING: 'MOVING',
    IDLING: 'IDLING',
    PARKING: 'PARKING',
    DISCONNECTED: 'DISCONNECTED' 
}

export const CHART_VEHICLE_TRANSIT_STATUS_OBJECT = {
    MOVING: 'MOVING',
    IDLING: 'IDLING',
    PARKING: 'PARKING'
}

const EVENT_TICKET_TYPES_OBJECT = {
    ALL: "ALL",
    INFO: "INFO",
    WARNING: "WARNING",
    CRITICAL: "CRITICAL",
    CONTROL: "CONTROL"
};

export const EVENT_TICKET_CODES = {
    INFO: 0,
    WARNING: 1,
    CRITICAL: 2
}

const EVENT_TICKET_TYPES_BY_CODES = {
    0: EVENT_TICKET_TYPES_OBJECT.INFO,
    1: EVENT_TICKET_TYPES_OBJECT.WARNING,
    2: EVENT_TICKET_TYPES_OBJECT.CRITICAL
}

const ALL_VEHICLE_TRANSIT_STATUS = 
    [ 
        VEHICLE_TRANSIT_STATUS_OBJECT.ALL,
        VEHICLE_TRANSIT_STATUS_OBJECT.MOVING, 
        VEHICLE_TRANSIT_STATUS_OBJECT.IDLING, 
        VEHICLE_TRANSIT_STATUS_OBJECT.PARKING, 
        VEHICLE_TRANSIT_STATUS_OBJECT.DISCONNECTED
    ]
const ALL_EVENT_TYPE = 
    [
        EVENT_TICKET_TYPES_OBJECT.ALL,
        EVENT_TICKET_TYPES_OBJECT.INFO,
        EVENT_TICKET_TYPES_OBJECT.WARNING,
        EVENT_TICKET_TYPES_OBJECT.CRITICAL,
        EVENT_TICKET_TYPES_OBJECT.CONTROL
    ]

const FILTERABLE_VEHICLE_TRANSIT_STATUS = 
    [
        VEHICLE_TRANSIT_STATUS_OBJECT.MOVING, 
        VEHICLE_TRANSIT_STATUS_OBJECT.IDLING, 
        VEHICLE_TRANSIT_STATUS_OBJECT.PARKING, 
        VEHICLE_TRANSIT_STATUS_OBJECT.DISCONNECTED
    ]

const FILTERABLE_EVENT_TYPE = 
    [ 
        EVENT_TICKET_TYPES_OBJECT.INFO,
        EVENT_TICKET_TYPES_OBJECT.WARNING,
        EVENT_TICKET_TYPES_OBJECT.CRITICAL,
        EVENT_TICKET_TYPES_OBJECT.CONTROL
    ]

const TRIP_STATUS_OBJECT = {
    TRANSIT: 'TRANSIT',
    PARKING: 'PARKING',
    DISCONNECTED: 'DISCONNECTED'
}

const TRANSIT_STATUS_OBJECT = {
    MOVING: 'MOVING',
    IDLING: 'IDLING',
    PARKING: 'PARKING',
    DISCONNECTED: 'DISCONNECTED'
}

const VEHICLE_TRANSIT_STATUS_COLOR = {
    [VEHICLE_TRANSIT_STATUS_OBJECT.ALL] : "#C4C4C4",
    [TRIP_STATUS_OBJECT.TRANSIT]: "#52C41A",
    [VEHICLE_TRANSIT_STATUS_OBJECT.MOVING] : "#52C41A",
    [VEHICLE_TRANSIT_STATUS_OBJECT.IDLING] : "#FFB517",
    [VEHICLE_TRANSIT_STATUS_OBJECT.PARKING] : "#0488DB",
    [VEHICLE_TRANSIT_STATUS_OBJECT.DISCONNECTED] : "#333333",
    // 'NULL': "#333333"
    'NULL': "#FFF"
}

export const CHART_VEHICLE_TRANSIT_STATUS_COLOR = {
    [VEHICLE_TRANSIT_STATUS_OBJECT.MOVING] : "#52C41A",
    [VEHICLE_TRANSIT_STATUS_OBJECT.IDLING] : "#FFB517",
    [VEHICLE_TRANSIT_STATUS_OBJECT.PARKING] : "#0488DB"
}

const VEHICLE_TRANSIT_STATUS_ICON = {
    [VEHICLE_TRANSIT_STATUS_OBJECT.ALL]: SVG_ALL,
    [VEHICLE_TRANSIT_STATUS_OBJECT.MOVING]: SVG_MOVING,
    [VEHICLE_TRANSIT_STATUS_OBJECT.IDLING]: SVG_IDLING, 
    [VEHICLE_TRANSIT_STATUS_OBJECT.PARKING]: SVG_PARKING,
    [VEHICLE_TRANSIT_STATUS_OBJECT.DISCONNECTED]: SVG_DISCONNECT
}

const EVENT_TICKET_COLOR = {
    [EVENT_TICKET_TYPES_OBJECT.ALL]: "#C4C4C4",
    // [EVENT_TICKET_TYPES_OBJECT.INFO]: "#52C41A", //old color: #37c837
    // [EVENT_TICKET_TYPES_OBJECT.WARNING]: "#FFB517", //old color: #7F2AFF
    // [EVENT_TICKET_TYPES_OBJECT.CRITICAL]: "#0488DB", //old color: #D4FF2A
    [EVENT_TICKET_TYPES_OBJECT.INFO]: "blue", //old color: #37c837
    [EVENT_TICKET_TYPES_OBJECT.WARNING]: "orange", //old color: #7F2AFF
    [EVENT_TICKET_TYPES_OBJECT.CRITICAL]: "red", //old color: #D4FF2A
    [EVENT_TICKET_TYPES_OBJECT.CONTROL]: "#856B37", //old color: #2A2AFF,
    'NULL': "#333333"
};

const TRIP_RECORD_EVENT_ICON = {
    [EVENT_TICKET_TYPES_OBJECT.INFO]: SVG_TRIP_EVENT_INFO,
    [EVENT_TICKET_TYPES_OBJECT.WARNING]: SVG_TRIP_EVENT_WARNING,
    [EVENT_TICKET_TYPES_OBJECT.CRITICAL]: SVG_TRIP_EVENT_CRITICAL
}

const EVENT_TICKET_TYPES_ICON = {
    [EVENT_TICKET_TYPES_OBJECT.ALL]: SVG_ALL,
    [EVENT_TICKET_TYPES_OBJECT.INFO]: SVG_INFO,
    [EVENT_TICKET_TYPES_OBJECT.WARNING]: SVG_WARNING,
    [EVENT_TICKET_TYPES_OBJECT.CRITICAL]: SVG_CRITICAL,
    [EVENT_TICKET_TYPES_OBJECT.CONTROL]: SVG_CONTROL
}

const TRANSIT_AND_EVENT_DURATIONS_OBJECT = {
    ALL: 'ALL',
    ONE_MINUTE: 'ONE_MINUTE',
    TWO_MINUTES: 'TWO_MINUTES',
    FIVE_MINUTES: 'FIVE_MINUTES',
    TEN_MINUTES: 'TEN_MINUTES',
    FIFTEEN_MINUTES: 'FIFTEEN_MINUTES',
    THIRTY_MINUTES: 'THIRTY_MINUTES'
}

const TRANSIT_AND_EVENT_DURATIONS_TYPE = {
    [TRANSIT_AND_EVENT_DURATIONS_OBJECT.ALL]: {
        label: 'ALL',
        value: 0
    },
    [TRANSIT_AND_EVENT_DURATIONS_OBJECT.ONE_MINUTE]: {
        label: '> 1 min',
        value: 60 * 1000
    },
    [TRANSIT_AND_EVENT_DURATIONS_OBJECT.TWO_MINUTES]: {
        label: '> 2 mins',
        value: 2 * 60 * 1000
    },
    [TRANSIT_AND_EVENT_DURATIONS_OBJECT.FIVE_MINUTES]: {
        label: '> 5 mins',
        value: 5 * 60 * 1000
    },
    [TRANSIT_AND_EVENT_DURATIONS_OBJECT.TEN_MINUTES]: {
        label: '> 10 mins',
        value: 10 * 60 * 1000
    },
    [TRANSIT_AND_EVENT_DURATIONS_OBJECT.FIFTEEN_MINUTES]: {
        label: '> 15 mins',
        value: 15 * 60 * 1000
    },
    [TRANSIT_AND_EVENT_DURATIONS_OBJECT.THIRTY_MINUTES]: {
        label: '> 30 mins',
        value: 30 * 60 * 1000
    },
}

export {
    ALL_VEHICLE_TRANSIT_STATUS,
    ALL_EVENT_TYPE,
    EVENT_SVG,
    EVENT_TICKET_COLOR,
    EVENT_TICKET_TYPES_ICON,
    EVENT_TICKET_TYPES_OBJECT,
    EVENT_TICKET_TYPES_BY_CODES,
    VEHICLE_TRANSIT_STATUS_COLOR,
    VEHICLE_TRANSIT_STATUS_ICON,
    VEHICLE_TRANSIT_STATUS_OBJECT,
    // Trip
    TRIP_STATUS_OBJECT,
    TRANSIT_STATUS_OBJECT,
    FILTERABLE_VEHICLE_TRANSIT_STATUS,
    FILTERABLE_EVENT_TYPE,
    TRIP_RECORD_EVENT_ICON,
    // Transit
    TRANSIT_AND_EVENT_DURATIONS_OBJECT,
    TRANSIT_AND_EVENT_DURATIONS_TYPE
}

const DRIVER_INDICATOR_COLOR = {
    BAD: 'red',
    // AVERAGE: 'orange',
    GOOD: '#FFB517',
    // VERY_GOOD: 'cyan',
    EXCELLENT: 'green'
}

export const driverScoreIndicator = (score) => {
    if(score >= 80) {
        return DRIVER_INDICATOR_COLOR.EXCELLENT
    }
    // else if(score >= 75) {
    //     return DRIVER_INDICATOR_COLOR.VERY_GOOD
    // }
    else if(score >= 60) {
        return DRIVER_INDICATOR_COLOR.GOOD
    }
    // else if(score >= 55) {
    //     return DRIVER_INDICATOR_COLOR.AVERAGE
    // }
    else {
        return DRIVER_INDICATOR_COLOR.BAD
    }
}

export const ALARM_TYPE_STATUS =  {
        "0": "Normal",
        "1": "Scheduled",
        "2": "Motion Detect ",
        "3": "Over Speed",
        "4": "Gsensor",
        "5": "Over Temperature",
        "6": "Alarm1",
        "7": "Alarm2",
        "8": "Alarm3",
        "9": "Alarm4",
        "10": "Alarm5",
        "11": "Alarm6",
        "12": "Alarm7",
        "13": "Alarm8",
        "14": "Button",
        "15": "RFID",
        "16": "Acceleration",
        "17": "Deceleration",
        "18": "Acc Turn",
        "19": "Gyr Turn",
        "20": "Impact",
        "21": "Gyr Turn Left",
        "22": "Gyr Turn Right",
        "23": "Manual Clip File",
        "24": "Button01",
        "25": "Button02",
        "26": "Button03",
        "27": "Button04",
        "28": "Button05",
        "29": "Button06",
        "30": "Button07",
        "31": "Button08",
        "32": "DMS Fatigue (Mild Fatigue)",
        "33": "DMS Distraction",
        "34": "DMS NoDriver",
        "35": "DMS Smoking",
        "36": "DMS Calling",
        "37": "ADAS Pedestrian Collision Warning (PCW)",
        "38": "ADAS Forward Collision Warning (FCW)",
        "39": "ADAS Lane Departure Warning (LDW)",
        "40": "ADAS Over Speed Warning",
        "41": "Snapshot",
        "42": "Radar",
        "43": "RFID Data Error",
        "44": "RFID Same Id",
        "45": "RFID Abnormal Number",
        "46": "Remove Memory Card",
        "47": "DMS Yawn",
        "48": "DMS Face Recognition Failure",
        "49": "DMS Not Wearing Mask",
        "50": "DMS Deep Fatigue (Moderate Fatigue)",
        "51": "High Temperature",
        "52": "Low Temperature",
        "53": "High Temperature Recovery",
        "54": "Low Temperature Recovery",
        "55": "Door Open",
        "56": "Door Closed",
        "57": "Sabotage Alarm",
        "58": "BSD Channel 1 Detection",
        "59": "BSD Channel 2 Detection",
        "60": "BSD Channel 3 Detection",
        "61": "BSD Channel 4 Detection",
        "62": "DMS Not Wearing Seat Belt",
        "63": "DMS Wearing Infrared Blocking Glasses",
        "64": "DMS Driver Changed",
        "65": "DMS Driver Changed",
        "66": "Electronic Fence",
        "67": "DMS Face Authentication Timeout",
        "68": "(deprecated) BSD Pedestrian Detection",
        "69": "(deprecated) BSD Vehicle Detection",
        "70": "(deprecated) BSD Pedestrian and Vehicle Detection",
        "71": "ADAS Stop Sign Alarm",
        "72": "ADAS Red Light Detection",
        "73": "DMS Face Authentication Successful",
        "74": "DMS Face Authentication Successful",
        "75": "DMS Face Authentication Successful",
        "76": "DMS Face Authentication Successful",
        "77": "DMS Calibration Successful",
        "78": "DMS Calibration Failed",
        "79": "DMS Drinking",
        "80": "ADAS Headway Monitoring and Warning (HMW)",
        "81": "ADAS Front Vehicle Start",
        "82": "DMS Irregular Steering",
        "83": "DMS No Safety Helmet",
        "84": "Lift Weighing",
        "85": "DMS Camera Installation Offset",
        "86": "IMS Taking Passengers Illegally",
        "87": "Monitor Disconnected",
        "88": "Vehicle Tilt",
        "89": "Lift Weighing 2",
        "90": "DMS Eating",
        "91": "Tire",
        "92": "Virtual Bumper Vehicle Alarm",
        "93": "Virtual Bumper Pedestrian Alarm",
        "94": "DMS Cumulative Fatigue Alarm",
        "95": "DMS Severe Fatigue Alarm (Severe Fatigue)"
    }